const SUGGESTION_REGEX = /<!-- suggestions:(\[.*?\]) -->/s;

export function parseSuggestions(content: string): {
  cleanContent: string;
  suggestions: string[];
} {
  const match = content.match(SUGGESTION_REGEX);
  if (!match) return { cleanContent: content, suggestions: [] };
  try {
    const suggestions = JSON.parse(match[1]);
    const cleanContent = content.replace(SUGGESTION_REGEX, "").trimEnd();
    return { cleanContent, suggestions: Array.isArray(suggestions) ? suggestions : [] };
  } catch {
    return { cleanContent: content, suggestions: [] };
  }
}
